import React, { useState } from "react";
import { Layout, Input, Button, message } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import authService from "../networks/api/service/authService";

const { Content } = Layout;

const VerifyPasswordOTP = () => {
  const [otp, setOtp] = useState("");
  const location = useLocation();
  const navigate = useNavigate();
  const email = location.state?.email;

  const verifyOTP = async () => {
    if (!otp) {
      message.warning("Please enter OTP");
      return;
    }

    try {
      const payload = {
        email,
        otp: Number(otp),
      };

      const res = await authService.verifyPasswordOtp(payload);

      if (res.code === 200) {
        message.success("OTP verified");
        navigate("/reset-password", { state: { email } });
      }
    } catch (error) {
      message.error("Invalid OTP");
    }
  };

  return (
    <Layout>
      <Content style={{ width: 400, margin: "100px auto" }}>
        <h2>Verify OTP</h2>

        <Input
          placeholder="Enter OTP"
          value={otp}
          onChange={(e) => setOtp(e.target.value)}
        />

        <Button
          type="primary"
          style={{ marginTop: 20, width: "100%" }}
          onClick={verifyOTP}
        >
          Verify OTP
        </Button>
      </Content>
    </Layout>
  );
};

export default VerifyPasswordOTP;